<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoDetalhar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso a essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoDetalhar">
			<form>
				<div class="formgroup">
					<div class="flex justify-content-center mt-3" *ngIf="loadingGrupos">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="w-auto mb-5">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
					<div class="p-fluid p-formgrid grid pt-3 px-3" *ngIf="grupo && !loadingGrupos">
						<div class="col-12 card-simple mb-3">
							<div class="p-fluid p-formgrid grid">
								<div class="col-12 md:col-3">
									<label class="label-superior">Descrição</label>
									<label class="label-inferior" id="descricao">{{ grupo.descricao }}</label>
								</div>
								<div class="col-12 md:col-3">
									<label class="label-superior">Empresa</label>
									<label class="label-inferior" id="empresa">{{ grupo.empresa?.nomeFantasia }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Tipo</label>
									<label class="label-inferior" id="tipo">{{ grupo.planoContaEmpresa?.descricao
										}}</label>
								</div>
								<div class="col-12 md:col-4">
									<label class="label-superior">CNPJ</label>
									<label class="label-inferior" id="tipo">{{ grupo.tributacaoEmpresa?.cnpj | cnpjFormat
										}}</label>
								</div>
							</div>
						</div>

						<div class="w-full mb-5">
							<p-table #dt1 [value]="listaSubgrupos" dataKey="id" [rows]="10" [rowHover]="true"
								styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="scroll"
								styleClass=" p-datatable-sm">
								<ng-template pTemplate="header">
									<tr>
										<th>
											<div class="flex justify-content-between align-items-center">
												Subgrupo
											</div>
										</th>
										<th *ngIf="grupoServico">
											<div class="flex justify-content-between align-items-center">
												Rateio Básico
											</div>
										</th>

									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-subgrupo>
									<tr>
										<td>
											<label>{{ subgrupo.descricao }}</label>
										</td>

										<td *ngIf="grupoServico">
											<label>{{ subgrupo.rateioBasico / 100 | percent:'1.2' }}</label>
										</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="emptymessage">
									<tr>
										<td colspan="7">Nenhum registro cadastrado.</td>
									</tr>
								</ng-template>
							</p-table>
						</div>
					</div>

					<div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loadingGrupos">
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/grupo">
							</button>
						</div>
					</div>

				</div>
			</form>
		</div>
	</div>
</div>